import React, { useMemo } from "react";
import { ToolbarDropdownButton } from "../comps/ToolbarDropdownButton";

import { ToolbarButton } from "../comps/ToolbarButton";
import { config } from "./config";
import { handleClick } from "./handleClick";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

export const HeadingTools = ({ activeNodeInfo, enableBlockLabelStyles }) => {
  const [editor] = useLexicalComposerContext();
  const checkIsActive = ({ tag, activeNodeInfo }) =>
    tag === activeNodeInfo?.__tag;

  // Block-label-style options (h4/h5) are opt-in via the
  // enableBlockLabelStyles prop. Currently turned on only by TCI
  // StaticRichText so other LexicalTextEditor mounts continue to
  // show only h1/h2/h3 in the heading dropdown.
  const visibleOptions = useMemo(
    () =>
      enableBlockLabelStyles
        ? config.options
        : config.options.filter((conf) => !conf.isBlockLabelStyle),
    [enableBlockLabelStyles]
  );

  return (
    <>
      <ToolbarDropdownButton
        isActive={visibleOptions.some((conf) =>
          checkIsActive({ tag: conf.tag, activeNodeInfo })
        )}
        icon={config.icon}
        noOfChildButtons={visibleOptions.length}
        genChildButtons={(setOpen) =>
          visibleOptions.map((conf) => {
            const { tag } = conf;
            const isActive = checkIsActive({ tag, activeNodeInfo });
            return (
              <ToolbarButton
                isActive={isActive}
                onClick={() => {
                  handleClick({ isActive, tag, editor });
                  setOpen(false);
                }}
                icon={conf.icon}
              />
            );
          })
        }
      />
    </>
  );
};
